var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.5C9.86841 18.5007 9.73797 18.4755 9.61615 18.4258C9.49432 18.376 9.38352 18.3027 9.29009 18.21L1.52113 10.4298C0.546625 9.44492 0 8.11527 0 6.72967C0 5.34406 0.546625 4.01442 1.52113 3.02957C2.50326 2.05005 3.83366 1.5 5.22064 1.5C6.60762 1.5 7.93801 2.05005 8.92014 3.02957L10 4.1096L11.0799 3.02957C12.062 2.05005 13.3924 1.5 14.7794 1.5C16.1663 1.5 17.4967 2.05005 18.4789 3.02957C19.4534 4.01442 20 5.34406 20 6.72967C20 8.11527 19.4534 9.44492 18.4789 10.4298L10.7099 18.21C10.6165 18.3027 10.5057 18.376 10.3839 18.4258C10.262 18.4755 10.1316 18.5007 10 18.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHart);
export default __webpack_public_path__ + "static/media/hart.963c593dd99096a28113bdee997f2bb3.svg";
export { ForwardRef as ReactComponent };